<template>
    <div id="currency_selection_box" name="currency_selection_box"> Show currencies in: &nbsp; <span class="currencyLinks">
    <a @click.prevent="$root.currency = ('GBP')">GBP</a>&nbsp;|&nbsp; <a @click.prevent="$root.currency = ('CHF')">CHF</a>&nbsp;|&nbsp; <a @click.prevent="$root.currency = ('AUD')">AUD</a>&nbsp;|&nbsp; <a @click.prevent="$root.currency = ('EUR')">EUR</a>&nbsp;|&nbsp; <a @click.prevent="$root.currency = ('USD')">USD</a>&nbsp;|&nbsp; <a @click.prevent="$root.currency = ('BRL')">BRL</a> &nbsp;|&nbsp; <a @click.prevent="$root.currency = ('ZAR')">ZAR</a>
  </span>
    </div>
</template>

<script>
    export default {}
</script>
